/**
 * Runtime configuration.
 *
 * Read from Vite env vars so the same built bundle is not reused across
 * environments by accident. Nothing here is secret: the admin panel is a public
 * OAuth client, which is why it uses PKCE, and every privileged action is
 * authorised server-side against the caller's realm role.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing ${name}. Copy .env.example to .env.local and fill it in before running the panel.`,
    )
  }
  return value
}

export const config = {
  apiBaseUrl: required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL),
  issuerUrl: required('VITE_KEYCLOAK_ISSUER', import.meta.env.VITE_KEYCLOAK_ISSUER),
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'pixviro-admin',
  redirectUri: `${window.location.origin}/auth/callback`,
  postLogoutRedirectUri: window.location.origin,
} as const
